// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3FEVn","content":"LayoutSettings_content__2eAQF"};